import React, { useState } from 'react';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import styles from './style.module.css';
import postSignInEmail from 'hooks/useSignInEmail';
import { SignInEmailFormContent } from 'services/content';
import { Spinner } from 'components';

const verifyRegExp = /^\d{6}$/;

const SignInMobileVerifyFormSchema = Yup.object().shape({
  code: Yup.string().matches(verifyRegExp, 'Please enter a six digit code'),
});

const SignInMobileVerifyForm = ({ authState, challenge, submittedEmail, callbackAuthExchange }) => {
  const valuesVerify = { code: '' };
  const [submitted, setSubmitted] = useState(false);
  const [emailSignin, emailSigninVerify] = postSignInEmail();

  const submitFormVerify = async (payload) => {
    setSubmitted(true);
    const verifyObjectEmail = {
      email: submittedEmail,
      code: payload.code,
      oauth: {
        client_id: window.OAUTH_CLIENTID,
        redirect_uri: window.NHS_REDIRECT_URI,
        scope: 'openid%20profile%20profile_extended%20gp_integration_credentials%20email%20phone',
        state: authState,
        code_challenge: challenge,
        code_challenge_method: 'S256',
      },
    };
    let authCode = '';
    try {
      authCode = await emailSigninVerify(verifyObjectEmail);
    } catch {
      return;
    }
    callbackAuthExchange(authCode);
  };

  return (
    <>
      {submitted ? (
        <Spinner />
      ) : (
        <Formik
          initialValues={valuesVerify}
          validationSchema={SignInMobileVerifyFormSchema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={(values) => submitFormVerify(values)}>
          {(props) => (
            <form className={styles.form} onSubmit={props.handleSubmit}>
              <label className={styles.inputLabel} htmlFor="code">
                {SignInEmailFormContent.verifyLabel}
                {submittedEmail}
              </label>
              <ErrorMessage
                name="code"
                render={(msg) => <div className={`coop-c-form-error__text ${styles.errorText}`}>{msg}</div>}
              />
              <input
                maxLength="6"
                id="code"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.code}
                className={`coop-form__input hp-form-input ${
                  props.errors.code && props.touched.code && 'coop-form__invalid'
                }`}
                name="code"
              />
              <button type="submit" className={`coop-btn coop-btn--secondary coop-c-hero__cta ${styles.submit}`}>
                {SignInEmailFormContent.verifyButton}
              </button>
            </form>
          )}
        </Formik>
      )}
    </>
  );
};

export default SignInMobileVerifyForm;
